import type { 
  GetTeamsData,
  GetTeamsResponse,

  GetTeamsByIdData,
  GetTeamsByIdResponse,

  PostTeamsData,
  PostTeamsResponse,

  PutTeamsByIdData,
  PutTeamsByIdResponse,

  DeleteTeamsByIdData,
  DeleteTeamsByIdResponse,

  GetTeamsByIdPermissionsData,
  GetTeamsByIdPermissionsResponse,

  PostTeamsByIdPermissionsData,
  PostTeamsByIdPermissionsResponse,

  GetAdminsData,
  GetAdminsResponse,

  GetAdminsByIdData,
  GetAdminsByIdResponse,

  PostAdminsData,
  PostAdminsResponse,

  PutAdminsByIdData,
  PutAdminsByIdResponse,

  DeleteAdminsByIdData,
  DeleteAdminsByIdResponse,

  PostAdminsByIdBlockData,
  PostAdminsByIdBlockResponse,

  PostAdminsByIdUnblockData,
  PostAdminsByIdUnblockResponse,

  PostAdminsByIdResetPasswordData,
  PostAdminsByIdResetPasswordResponse,

  PostAdminsByIdResetTotpData,
  PostAdminsByIdResetTotpResponse,

  PostAdminsByIdAttachToTeamData,
  PostAdminsByIdAttachToTeamResponse,

  PostAdminsByIdDetachFromTeamData,
  PostAdminsByIdDetachFromTeamResponse,

  PostAdminsByIdAttachAffiliateData,
  PostAdminsByIdAttachAffiliateResponse,

  PostAdminsByIdDetachAffiliateData,
  PostAdminsByIdDetachAffiliateResponse,

  GetAdminsByIdAffiliatesData,
  GetAdminsByIdAffiliatesResponse,

  GetAdminsByIdTeamsPermissionsPreviewData,
  GetAdminsByIdTeamsPermissionsPreviewResponse,

  GetAdminsByIdPermissionsData,
  GetAdminsByIdPermissionsResponse,

  PostAdminsByIdPermissionsData,
  PostAdminsByIdPermissionsResponse,
} from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";

export function getTeamApiModule(affiliatesApi: AxiosInstance) {
  return {
    // team
    getTeamsList(params: GetTeamsData['query']) {
      return affiliatesApi.get<GetTeamsResponse>('/teams', { params });
    },
    getTeam(id: string) {
      return affiliatesApi.get<GetTeamsByIdResponse>(`/teams/${id}`);
    },
    postTeam(name: PostTeamsData['body']['name']) {
      return affiliatesApi.post<PostTeamsResponse>('/teams', { name });
    },
    putTeam(id: string, name: PutTeamsByIdData['body']['name']) {
      return affiliatesApi.put<PutTeamsByIdResponse>(`/teams/${id}`, { name });
    },
    deleteTeam(id: string) {
      return affiliatesApi.delete<DeleteTeamsByIdResponse>(`/teams/${id}`);
    },
    // attachAdmin(id: string, admin_id) {
    //   return affiliatesApi.post(`/teams/${id}/attach-admin`, { admin_id });
    // },

    getTeamPermissions(id: string) {
      return affiliatesApi.get<GetTeamsByIdPermissionsResponse>(`/teams/${id}/permissions`);
    },
    postTeamPermissions(id: string, data: PostTeamsByIdPermissionsData['body']) {
      return affiliatesApi.post<PostTeamsByIdPermissionsResponse>(`/teams/${id}/permissions`, data);
    },

    // Admin
    getAdmins(params: GetAdminsData['query']) {
      return affiliatesApi.get<GetAdminsResponse>('/admins', { params });
    },
    getAdmin(id: string) {
      return affiliatesApi.get<GetAdminsByIdResponse>(`/admins/${id}`);
    },
    postAdmins(data: PostAdminsData['body']) {
      return affiliatesApi.post<PostAdminsResponse>('/admins', data);
    },
    putAdmins(id: string, data: PutAdminsByIdData['body']) {
      return affiliatesApi.put<PutAdminsByIdResponse>(`/admins/${id}`, data);
    },
    deleteAdmins(id: string) {
      return affiliatesApi.delete<DeleteAdminsByIdResponse>(`/admins/${id}`);
    },
    postBlock(id: string) {
      return affiliatesApi.post<PostAdminsByIdBlockResponse>(`/admins/${id}/block`);
    },
    postUnblock(id: string) {
      return affiliatesApi.post<PostAdminsByIdUnblockResponse>(`/admins/${id}/unblock`);
    },
    postResetPassword(id: string) {
      return affiliatesApi.post<PostAdminsByIdResetPasswordResponse>(`/admins/${id}/reset-password`);
    },
    postResetTotp(id: string) {
      return affiliatesApi.post<PostAdminsByIdResetTotpResponse>(`/admins/${id}/reset-totp`);
    },

    postAttachToTeam(id: string, team_id: PostAdminsByIdAttachToTeamData['body']['team_id']) {
      return affiliatesApi.post<PostAdminsByIdAttachToTeamResponse>(`/admins/${id}/attach-to-team`, { team_id });
    },
    postDetachFromTeam(id: string, team_id: PostAdminsByIdDetachFromTeamData['body']) {
      return affiliatesApi.post<PostAdminsByIdDetachFromTeamResponse>(`/admins/${id}/detach-from-team`, team_id);
    },

    postAttachAffiliate(id: string, { affiliate_id, team_id }: PostAdminsByIdAttachAffiliateData['body']) {
      return affiliatesApi.post<PostAdminsByIdAttachAffiliateResponse>(
        `/admins/${id}/attach-affiliate`,
        { affiliate_id, team_id }
      );
    },
    postDetachAffiliate(id: string, { affiliate_id, team_id }: PostAdminsByIdDetachAffiliateData['body']) {
      return affiliatesApi.post<PostAdminsByIdDetachAffiliateResponse>(
        `/admins/${id}/detach-affiliate`,
        { affiliate_id, team_id }
      );
    },
    getAdminAffiliates(id: string, params: GetAdminsByIdAffiliatesData['query']) {
      return affiliatesApi.get<GetAdminsByIdAffiliatesResponse>(`/admins/${id}/affiliates`, { params });
    },

    getAdminAcl(id: string) {
      return affiliatesApi.get<GetAdminsByIdTeamsPermissionsPreviewResponse>(`/admins/${id}/teams-permissions-preview`);
    },
    getAdminPermissions(id: string, team_id: GetAdminsByIdPermissionsData['query']['team_id']) {
      return affiliatesApi.get<GetAdminsByIdPermissionsResponse>(`/admins/${id}/permissions`, { params: { team_id } });
    },
    postAdminPermissions(
      id: string,
      team_id: PostAdminsByIdPermissionsData['query']['team_id'],
      data: PostAdminsByIdPermissionsData['body']
    ) {
      return affiliatesApi.post<PostAdminsByIdPermissionsResponse>(`/admins/${id}/permissions?team_id=${team_id}`, data);
    },
  }
};
